import { render, staticRenderFns } from "./UpdateGallery.vue?vue&type=template&id=4fb41876&scoped=true&"
import script from "./UpdateGallery.vue?vue&type=script&lang=js&"
export * from "./UpdateGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb41876",
  null
  
)

export default component.exports